import React from 'react';

import { ChevronDown, ChevronUpOutline } from '@lyearn/icons';

import LinkButton from '../LinkButton';
import Stack from '../Stack';
import Typography from '../Typography';
import { TypographyVariants } from '../Typography/types';

interface NumberInputEndAdornmentParams {
  endIcon?: React.ReactNode;
  inputSuffix?: string;
  onDecrease: () => void;
  onIncrease: () => void;
  showControls: boolean;
  variant: TypographyVariants;
}

export const renderNumberInputEndAdornment = (params: NumberInputEndAdornmentParams) => {
  const { endIcon, inputSuffix, onDecrease, onIncrease, showControls, variant } = params;

  if (!inputSuffix && !endIcon && !showControls) {
    return null;
  }

  return (
    <Stack alignItems="center" className="flex-1" justifyContent={inputSuffix ? 'between' : 'end'}>
      {inputSuffix ? (
        <Typography color="text-text-placeholder" variant={variant}>
          {inputSuffix}
        </Typography>
      ) : null}
      <Stack alignItems="center">
        {endIcon}
        {showControls ? (
          <Stack className="h-full" direction="col">
            <LinkButton Icon={ChevronUpOutline} onClick={onIncrease} />
            <LinkButton Icon={ChevronDown} className="-mt-6" onClick={onDecrease} />
          </Stack>
        ) : null}
      </Stack>
    </Stack>
  );
};
